export enum CustomerBankAccountField {
  ID = 'ID',
  BIC = 'BIC',
  IBAN = 'IBAN',
  CUSTOMER_NAME = 'CUSTOMER_NAME'
}
